import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaEdit, FaEye, FaTrash, FaComment } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BACKEND } from "../../config/configEnvs";
import { format, differenceInDays } from "date-fns";
import { es } from "date-fns/locale";
import Moment from "react-moment";
import "moment-timezone";
import "moment/locale/es"; // Import the Spanish locale

import "tippy.js/dist/tippy.css";
import { GetStatusColor } from "../../utils/GetTextColor";
import { CapitalizeEachWord } from "../../utils/CapitalizeLetters";
import { EliminarCotizacion } from "../../utils/automateFuncions/ElminarCotizacion";
import Tooltip from "../ui/ToolTip";
import { FormatDateToDDMMYY, FormatDateToDDMMYYHHMM } from "../../utils/FormatDate";
import DetailsButton from "../ui/components/DetailsButton"
import DeleteButton from "../ui/components/DeleteButton";
import { FaDesktop } from "react-icons/fa6";
import { dateCalendarClasses } from "@mui/x-date-pickers";

const CotizacionItemRow = React.memo(({ data, onRefresh, onSelect, statusColor, subStatusColor, isAdmin, flagUrl }) => {
  
  const [numberOfPagos, setNumberOfPagos] = useState(0);
  const [pagosList, setPagosList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  
  const textServices = servicesList.map((s) => s.servicio.name).join("\n ");

  const getNumeroPagos = async () => {
    if (data?.id) {
      const response = await axios.get(`${BACKEND}/api/pagosCotizaciones?where[cotizacion][equals]=${data?.id}&depth=0&limit=0`);
      setNumberOfPagos(response.data.docs.length);
      setPagosList(response.data.docs);
    }
  };

  const getServices = async () => {
    if (data?.id) {
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones?where[cotizacion][equals]=${data?.id}&depth=1&limit=0`);
      setServicesList(response.data.docs);
    }
  };

  useEffect(() => {
    getNumeroPagos();
    getServices();
  }, []);

  return (
    <>
      <tr
        key={data.id}
        className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100"
      >
        <td className="px-4 border border-gray-300">
          <DetailsButton content="Ver detalles" action={() => onSelect()} />
        </td>
        {isAdmin && (
          <td className="px-4 py-3 text-gray-900 font-bold text-center whitespace-nowrap border border-gray-300">
            <DeleteButton content="Eliminar cotización" action={() => EliminarCotizacion(data?.id, data.estado, onRefresh)} />
          </td>
        )}
        <td className={`px-4 py-3 font-bold text-center whitespace-nowrap border border-gray-300`}>
          {data?.comentario ? (
            <Tooltip content={data?.comentario}>
              <div className="flex justify-center items-center text-gray-800 hover:cursor-pointer">
                <FaComment />
              </div>
            </Tooltip>
          ) : (
            <div className="flex justify-center items-center text-gray-200">
              <FaComment />
            </div>
          )}
        </td>
        <td className={`px-4 py-3 text-gray-900 whitespace-nowrap border border-gray-300`}>
          <ul className="list-disc pl-4">
            {servicesList.map((s, index) => (
              <li key={index}>{s.servicio.name}</li>
            ))}
          </ul>
        </td>
        <td className={`px-4 py-3 text-gray-900 font-bold text-center whitespace-nowrap border border-gray-300 ${GetStatusColor(data?.estado, statusColor)}`}>
          {data?.estado}
        </td>
        <td className={`px-4 py-3 text-gray-900 font-bold text-center whitespace-nowrap border border-gray-300 ${GetStatusColor(data?.subEstado, subStatusColor)}`}>
          {(!data?.subEstado || data?.subEstado === "Seleccionar") ? "-" : data?.subEstado}
        </td>
        <td className={`px-4 py-3 text-gray-900 text-center whitespace-nowrap border border-gray-300`}>
          {data?.ultimaActualizacionSubestado ? FormatDateToDDMMYYHHMM(data?.ultimaActualizacionSubestado) : "-"}
        </td>
        <td className="px-4 py-3 border border-gray-300 text-center">
          <span>{data?.cotizador?.name}</span>
        </td>
        <td className="px-4 py-3 border border-gray-300 text-center">
          <Moment date={data.createdAt} format=" MMMM " utc locale="es" />
        </td>
        <td className="px-4 py-3 border border-gray-300 text-center">
          <Moment date={data.createdAt} format=" YYYY " utc locale="es" />
        </td>
        <td className="px-4 py-3 border border-gray-300">
          {CapitalizeEachWord(data.cliente?.nombreComercial)}
        </td>
        <td className="px-4 py-3 border border-gray-300">
          {CapitalizeEachWord(data?.lead?.leadName) || CapitalizeEachWord(data?.leadNombre)}
        </td>
        <td className="px-4 py-3 border border-gray-300 whitespace-nowrap">
          {data?.cliente?.telefono || data?.lead?.phone}
        </td>
        <td className="px-2 py-3 border border-gray-300 text-center">
          {data?.createdAt && (
            <Moment
              date={data.createdAt}
              format="D MMM YYYY "
              utc
              locale="es"
            />
          )}
        </td>
        <td className="px-2 py-3 border border-gray-300 text-center">
          {data?.fechaVenta && (
            <Moment
              date={data.fechaVenta}
              format="D MMM YYYY "
              utc
              locale="es"
            />
          )}
        </td>
        <td className="px-2 py-3 border border-gray-300 text-center">
          {data?.fechaCotizacionLimite && (
            <Moment
              date={data.fechaCotizacionLimite}
              format="D MMM YYYY "
              utc
              locale="es"
            />
          )}
        </td>
        <td className="px-4 py-3 border border-gray-300 text-center">
          {/* {data.moneda} */}
          <div className="flex items-center justify-center gap-2">
            {data.cliente?.pais || data.lead?.country}
            {flagUrl ? (
              <img src={flagUrl} alt="flag" className="w-4 h-4 rounded-full z-10" />
            ) : (
              data.cliente?.pais || data.lead?.country
            )}
          </div>
        </td>
        <td className={`px-4 py-3 border border-gray-300 text-center ${data.comparativo ? "text-gray-300" : ""}`}>
          {data.comparativo ? (
            <Tooltip content="Esta cotización es una comparativa, por lo que el precio total no es el real.">
              <div className="flex justify-center items-center hover:cursor-pointer">
                {pagosList.length ? pagosList.reduce((acc, value) => value.precio + acc, 0).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
              </div>
            </Tooltip>
            ) : (
              pagosList.length ? pagosList.reduce((acc, value) => value.precio + acc, 0).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"
            )
          }
        </td>
        <td className="px-4 py-3 border border-gray-300 text-center">
          {data.estado === "Exito" ? (
            pagosList.filter((pago) => pago.pagado === false).reduce((acc, value) => value.precio + acc, 0).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          ) : (
            "-"
          )}
        </td>
        <td className="px-1 py-3 border border-gray-300 text-center">
          {numberOfPagos}
        </td>
      </tr>
    </>
  );
});

export default CotizacionItemRow;
